import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/RoomtypesTable.styles'

const UserRowMobileSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRowMobileSkeleton}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
      </div>
    </>
  )
}

export default UserRowMobileSkeleton
